/**
 * Returns the display label for an accounting item based on the selected display field.
 *
 * @param {Object} item - The accounting item object
 * @param {string} displayField - The field to display ("name", "actual_name", "number", "description")
 * @returns {string|null} The display label
 */
export const getAccountingItemLabel = (item, displayField = "name") => {
  if (!item) { return null; }

  const value = item[displayField];
  if (value !== null && value !== undefined && value !== "") { return value; }

  // Fallback to name, then number
  return item.name || item.number || null;
};

/**
 * Sorts dropdown options A to Z by the text the user actually sees.
 *
 * Numbers inside the text are compared as numbers, not as characters. MYOB job
 * labels look like "59 / Apex", so this keeps them in the order a person
 * expects (56, 57, 59, 102) instead of 102, 56, 57, 59.
 *
 * @param {Array<{label: string}>} options - Mapped options, without the placeholder
 * @returns {Array<{label: string}>} A new sorted array
 */
export const sortOptionsByLabel = (options) =>
  [...options].sort((a, b) =>
    (a?.label ?? "").localeCompare(b?.label ?? "", undefined, {
      numeric: true,
      sensitivity: "base",
    })
  );
